import { OverlayToolbar } from "@/components/ui/overlay-toolbar";
import { ToolGroup } from "@faro-lotv/flat-ui";
import type { JSX } from "react";
import { MultiSheetToolButton } from "./ui-components/multi-sheet-tool-button";

/** @returns A toolbar with visibility settings */
export function TagsManagementViewToolbar(): JSX.Element {
  return (
    <OverlayToolbar>
      <ToolGroup>
        <MultiSheetToolButton />
      </ToolGroup>
    </OverlayToolbar>
  );
}
